export const currencyOptions = [
    { value: 'eur', label: 'EUR', sign: '€' },
    { value: 'usd', label: 'USD', sign: '$' },
    { value: 'gbp', label: 'GBP', sign: '£' }
];

export const webHostingPlans = {
    eur: {
        year_1: {
            solo: 2.49,
            multisite: 4.49,
            cloud_1: 6.49,
            cloud_2: 9.49,
            cloud_3: 12.49
        },
        year_2: {
            solo: 2.29,
            multisite: 4.29,
            cloud_1: 6.29,
            cloud_2: 9.29,
            cloud_3: 12.29
        },
        year_3: {
            solo: 1.89,
            multisite: 3.89,
            cloud_1: 5.89,
            cloud_2: 8.89,
            cloud_3: 11.89
        }
    },
    usd: {
        year_1: {
            solo: 2.89,
            multisite: 5.89,
            cloud_1: 7.89,
            cloud_2: 11.89,
            cloud_3: 14.89
        },
        year_2: {
            solo: 2.59,
            multisite: 5.59,
            cloud_1: 7.59,
            cloud_2: 11.59,
            cloud_3: 14.59
        },
        year_3: {
            solo: 2.29,
            multisite: 5.29,
            cloud_1: 7.29,
            cloud_2: 11.29,
            cloud_3: 14.29
        }
    },
    gbp: {
        year_1: {
            solo: 2.29,
            multisite: 4.29,
            cloud_1: 6.29,
            cloud_2: 9.29,
            cloud_3: 12.29
        },
        year_2: {
            solo: 1.89,
            multisite: 3.89,
            cloud_1: 5.89,
            cloud_2: 8.89,
            cloud_3: 11.89
        },
        year_3: {
            solo: 1.69,
            multisite: 3.49,
            cloud_1: 5.49,
            cloud_2: 8.49,
            cloud_3: 11.49
        }
    }
};

export const emailPlans = {
    eur: {
        year_1: {
            mailpro: 1.89,
            mailpro_plus: 2.89
        },
        year_2: {
            mailpro: 1.69,
            mailpro_plus: 2.69
        },
        year_3: {
            mailpro: 1.49,
            mailpro_plus: 2.49
        }
    },
    usd: {
        year_1: {
            mailpro: 2.29,
            mailpro_plus: 3.49
        },
        year_2: {
            mailpro: 1.89,
            mailpro_plus: 3.29
        },
        year_3: {
            mailpro: 1.69,
            mailpro_plus: 2.89
        }
    },
    gbp: {
        year_1: {
            mailpro: 1.69,
            mailpro_plus: 2.59
        },
        year_2: {
            mailpro: 1.59,
            mailpro_plus: 2.39
        },
        year_3: {
            mailpro: 1.39,
            mailpro_plus: 2.19
        }
    }
};

export const vpsPlans = {
    eur: {
        month_1: {
            vps_start: 5.99,
            vps_grow: 9.99,
            vps_advance: 17.99
        },
        month_6: {
            vps_start: 5.49,
            vps_grow: 8.99,
            vps_advance: 15.99
        },
        month_12: {
            vps_start: 4.99,
            vps_grow: 8.49,
            vps_advance: 14.99
        }
    },
    usd: {
        month_1: {
            vps_start: 6.49,
            vps_grow: 10.99,
            vps_advance: 19.99
        },
        month_6: {
            vps_start: 5.99,
            vps_grow: 9.99,
            vps_advance: 17.99
        },
        month_12: {
            vps_start: 5.49,
            vps_grow: 8.99,
            vps_advance: 16.99
        }
    },
    gbp: {
        month_1: {
            vps_start: 5.49,
            vps_grow: 8.99,
            vps_advance: 15.99
        },
        month_6: {
            vps_start: 4.99,
            vps_grow: 7.99,
            vps_advance: 13.99
        },
        month_12: {
            vps_start: 4.59,
            vps_grow: 7.49,
            vps_advance: 12.99
        }
    }
};

export const webHostingCloud = {
    cloud_1: {
        entry_process: '100',
        cpu: '2',
        cpu_operations: '2048',
        cpu_speed: 'Unlimited',
        ram: '4GB',
        ram_fr: '4Go',
        ssd: '150GB',
        ssd_fr: '150Go',
        title: '4G',
        total_processes: '200'
    },
    cloud_2: {
        entry_process: '200',
        cpu: '4',
        cpu_operations: '3072',
        cpu_speed: 'Unlimited',
        ram: '8GB',
        ram_fr: '8Go',
        ssd: '200GB',
        ssd_fr: '200Go',
        title: '8G',
        total_processes: '300'
    },
    cloud_3: {
        entry_process: '300',
        cpu: '6',
        cpu_operations: '4096',
        cpu_speed: 'Unlimited',
        ram: '12GB',
        ram_fr: '12Go',
        ssd: '250GB',
        ssd_fr: '250Go',
        title: '12G',
        total_processes: '500'
    }
};

export const domainPrices = {
    usd: {
        com: 13.79,
        net: 14.79,
        fr: 9.49,
        be: 9.79,
        org: 13.79,
        eu: 8.79,
        biz: 21.79,
        info: 23.49,
        uk: 11.49,
        us: 11.49,
        tv: 31.49,
        it: 8.49,
        co: 44.49,
        de: 8.49,
        es: 8.69,
        ch: 12.79,
        ca: 12.49,
        me: 21.49,
        pro: 26.49,
        in: 11.49,
        lu: 38.49,
        io: 55.49,
        xyz: 18.49,
        ru: 38.49,
        nl: 8.79,
        re: 8.69,
        pm: 7.49,
        wf: 8.69,
        yt: 7.49,
        ma: 17.49,
        cm: 73.89,
        ci: 13.49,
        bi: 38.49,
        app: 21.79
    },
    gbp: {
        com: 10.49,
        net: 11.49,
        fr: 6.79,
        be: 7.49,
        org: 10.89,
        eu: 6.49,
        biz: 16.49,
        info: 17.49,
        uk: 8.49,
        us: 8.49,
        tv: 25.49,
        it: 6.49,
        co: 32.79,
        de: 6.49,
        es: 6.49,
        ch: 9.49,
        ca: 9.49,
        me: 16.49,
        pro: 19.79,
        in: 8.49,
        lu: 28.49,
        io: 41.49,
        xyz: 13.49,
        ru: 28.49,
        nl: 7.49,
        re: 6.49,
        pm: 5.89,
        wf: 6.49,
        yt: 5.89,
        ma: 14.49,
        cm: 58.89,
        ci: 10.49,
        bi: 28.49,
        app: 16.79
    },
    eur: {
        com: 11.79,
        net: 12.79,
        fr: 7.79,
        be: 8.49,
        org: 12.49,
        eu: 7.49,
        biz: 18.79,
        info: 19.79,
        uk: 9.79,
        us: 9.79,
        tv: 29.79,
        it: 6.79,
        co: 37.79,
        de: 6.79,
        es: 7.49,
        ch: 10.79,
        ca: 10.49,
        me: 18.49,
        pro: 22.79,
        in: 9.79,
        lu: 32.79,
        io: 47.79,
        xyz: 15.49,
        ru: 32.79,
        nl: 8.49,
        re: 7.49,
        pm: 6.89,
        wf: 7.49,
        yt: 6.89,
        ma: 16.49,
        cm: 68.89,
        ci: 11.89,
        bi: 32.79,
        app: 16.79
    }
};

export const resellerPlanPrices = {
    eur: {
        per_month: 14.79,
        extra_account: 1.49,
        extra_gb: 0.05
    },
    usd: {
        per_month: 17.49,
        extra_account: 1.69,
        extra_gb: 0.05
    },
    gbp: {
        per_month: 12.89,
        extra_account: 1.29,
        extra_gb: 0.05
    }
};
